import {
    put,
    call,
    takeLatest,
} from 'redux-saga/effects';

import {CREATE_COMPANY, LIST_COMPANIES, UPDATE_COMPANY} from "../../constants/settings";
import {hideError, showErrorMessage} from "../../actions/global";
import {storeCompanies} from "../../actions/settings";
import AuthUtil from "../../AuthUtil";
import {SERVER_FAILED_ERROR_MESSAGE} from "../../../components/dashboard/constants";
import {COMPANY} from "../../../components/global/Server/endpoints";


function* listCompaniesSaga() {
    yield put(hideError())
    try {
        const response = yield call(() => AuthUtil.getRequest(COMPANY.LIST_COMPANIES))
        yield put(storeCompanies(response.data))
    } catch (error) {
        yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE))
    }
}

function* createCompanySaga(action) {
    yield put(hideError())
    try {
        const response = yield call(() => AuthUtil.postRequest(COMPANY.CREATE_COMPANY, action.company))
        if (response.data.success) {
            yield put(storeCompanies(response.data.companies))
            action.refresh()
        } else {
            yield put(showErrorMessage(response.data.message))
        }
    } catch (error) {
        yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE))
    }
}

function* updateCompanySaga(action) {
    yield put(hideError())
    try {
        const response = yield call(() => AuthUtil.postRequest(COMPANY.UPDATE_COMPANY, action.updatedCompany))
        if (response.data.success) {
            yield put(storeCompanies(response.data.companies))
        } else {
            yield put(showErrorMessage(response.data.message))
        }

    } catch (error) {
        yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE))
    }
}

export default function* settingsSagas() {
    yield takeLatest(LIST_COMPANIES, listCompaniesSaga)
    yield takeLatest(CREATE_COMPANY, createCompanySaga)
    yield takeLatest(UPDATE_COMPANY, updateCompanySaga)
};